import { LanguageSwitcher } from "#/components/locale/language-switcher";
import ThemeToggle from "#/components/ThemeToggle";

export function HeaderActions() {
	return (
		<div className="hidden items-center gap-2 md:flex">
			<LanguageSwitcher />

			<ThemeToggle />
		</div>
	);
}
